import { IndexedFilters } from '../types/filters';

/**
 * Checks if the selected filters only include the canonical make/model.
 * @param selectedFilters The current selected filters object.
 * @param make The canonical make (string, case-sensitive).
 * @param model The canonical model (string, case-insensitive).
 * @returns true if only the make/model are selected, false otherwise.
 */
export function onlyMakeModelSelected(
  selectedFilters: IndexedFilters,
  make?: string,
  model?: string
): boolean {
  // There should be only one key: 'makes'
  const filterKeys = Object.keys(selectedFilters);
  if (filterKeys.length !== 1 || filterKeys[0] !== 'makes') return false;
  // The canonical make must be provided
  if (!make) return false;
  const makesObj = selectedFilters.makes as Record<string, string[]>;
  const makeKeys = Object.keys(makesObj);
  // There should be only one make, and it must match the canonical make
  if (makeKeys.length !== 1 || makeKeys[0] !== make) return false;
  const selectedModels = makesObj[make] || [];
  // If a canonical model is provided, it must be the only selected model (case-insensitive)
  if (model) {
    return (
      selectedModels.length === 1 &&
      selectedModels[0].toLowerCase() === model.toLowerCase()
    );
  }
  // If no canonical model, there should be no models selected
  return selectedModels.length === 0;
}
